export class Browseissue {

	init() {
		$( '.browse-issue' ).select2( {
			minimumResultsForSearch: -1,
		} )
	}
}


// WEBPACK FOOTER //
// ./scripts/components/browse-issue.js